<template>
  <el-table
    class="common-el-table-styles summary-el-table-styles"
    ref="table"
    border
    stripe
    v-loading="loading"
    show-summary
    :data="data"
    :height="height"
    :summary-method="summary"
    @sort-change="$emit('on-sort', $event)"
  >
    <el-table-column
      v-for="(col, id) in columns"
      :key="id"
      :prop="col.key"
      :label="col.title"
      :fixed="col.fixed"
      :show-overflow-tooltip="col.overflow"
      :min-width="col.width"
      :align="col.align"
      :sortable="col.sortable"
      :sort-orders="['descending', 'ascending', null]"
    >
      <template slot-scope="scope">
        <span v-if="['pv', 'clickNum', 'paperUseAmount', 'amount', 'newRoleMoney'].includes(col.key)">
          {{ scope.row[col.key] | toThousands }}
        </span>
        <span
          v-else-if="
            [
              'clickRate',
              'payRoleUserRate',
              'newRoleRate',
              'nextDayRetainRate',
              'threeDayRetainRate',
              'sevenDayRetainRate',
              'thirtyDayRetainRate',
              'createRoleTwoDayRetainRate',
              'createRoleThreeDayRetainRate',
              'createRoleFourDayRetainRate',
              'createRoleFiveDayRetainRate',
              'createRoleSixDayRetainRate',
              'createRoleSevenDayRetainRate',
              'createRoleTenDayRetainRate',
              'createRoleFifteenDayRetainRate',
              'createRoleThirtyDayRetainRate',
              'createRole24hRoi',
              'createRoleRoi1d',
              'createRoleRoi3d',
              'createRoleRoi7d'
            ].includes(col.key)
          "
          >{{ scope.row[col.key] | toPercentFixed }}
        </span>
        <span v-else>{{ scope.row[col.key] }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: 'MDetailTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Function
    },
    height: {
      type: Number
    }
  }
}
</script>
